exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{background-color:white;padding:1em 0}.DatoCMS-button--simple{background-color:#e4e4e4}\n", ""]);

// exports
